import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class FiltersFormController extends Controller<HTMLFormElement> {
  declare readonly filterLinkTarget: HTMLAnchorElement
  declare readonly hiddenFieldsetTargets: HTMLFieldSetElement[]
  static targets = ["filterLink", "hiddenFieldset"]

  connect(): void {
    // Reset form controls so back button behaves as expected
    this.element.reset()
  }

  applyFilter(e: Event): void {
    const url = (e.target as HTMLElement)?.dataset.url
    if (!url) return

    e.preventDefault()

    this.filterLinkTarget.setAttribute("href", url)
    this.filterLinkTarget.click()
  }

  scrollIntoView({ currentTarget }: ActionEvent): void {
    ;(currentTarget as HTMLElement).scrollIntoView({
      behavior: "instant",
      block: "nearest", // To avoid vertical scrolls
      inline: "center"
    })
  }

  // TODO[NEW_SEARCH_PAGE]: Remove this function (and target) when feature switch gone.
  showAll(e: Event): void {
    const button = e.currentTarget as HTMLButtonElement
    const hiddenFilters = this.hiddenFieldsetTargets.find((fieldset) => {
      return button.parentElement?.contains(fieldset)
    })

    hiddenFilters?.removeAttribute("hidden")
    button?.remove()
  }
}
